"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ListArticle = ListArticle;
exports.activeCustomersApi = activeCustomersApi;
exports.adminStopAllTasks = adminStopAllTasks;
exports.batchDeleteExpiredTasks = batchDeleteExpiredTasks;
exports.cancelOrder = cancelOrder;
exports.cancelQueuedTask = cancelQueuedTask;
exports.changeOrderState = changeOrderState;
exports.createAsyncCustomerExportTask = createAsyncCustomerExportTask;
exports.createAsyncEnhancedExportTask = createAsyncEnhancedExportTask;
exports.createAsyncFinanceExportTask = createAsyncFinanceExportTask;
exports.createAsyncOrderExportTask = createAsyncOrderExportTask;
exports.createAsyncSupplierOrderExportTask = createAsyncSupplierOrderExportTask;
exports.deleteDownloadTask = deleteDownloadTask;
exports.downloadFile = downloadFile;
exports.downloadFileByPath = downloadFileByPath;
exports.enhancedExportOrderList = enhancedExportOrderList;
exports.exportCustomerOrderList = exportCustomerOrderList;
exports.exportFinanceList = exportFinanceList;
exports.exportMovieOrderList = exportMovieOrderList;
exports.exportOfflineOrder = exportOfflineOrder;
exports.exportOrderList = exportOrderList;
exports.exportOrderList2 = exportOrderList2;
exports.exportOrderSendList = exportOrderSendList;
exports.exportOrderSendList2 = exportOrderSendList2;
exports.exportOrderSendListSplit = exportOrderSendListSplit;
exports.fastExportOrderList = fastExportOrderList;
exports.getCustomrOrder = getCustomrOrder;
exports.getDashboardSummary = getDashboardSummary;
exports.getDeliveryTrace = getDeliveryTrace;
exports.getDownloadQueueDetail = getDownloadQueueDetail;
exports.getDownloadQueueInfo = getDownloadQueueInfo;
exports.getDownloadTaskDetail = getDownloadTaskDetail;
exports.getDownloadTaskList = getDownloadTaskList;
exports.getDownloadTaskStatistics = getDownloadTaskStatistics;
exports.getDownloadTaskStatus = getDownloadTaskStatus;
exports.getExportTaskStatus = getExportTaskStatus;
exports.getFudouDetail = getFudouDetail;
exports.getMovieOrderDetail = getMovieOrderDetail;
exports.getOfflineOrderExportTaskStatus = getOfflineOrderExportTaskStatus;
exports.getOrderDetail = getOrderDetail;
exports.getOrderDetail2 = getOrderDetail2;
exports.getOrderDiscountDetail = getOrderDiscountDetail;
exports.getOrderOneCardList = getOrderOneCardList;
exports.getOrderPayDetail = getOrderPayDetail;
exports.getOrderPayList = getOrderPayList;
exports.getOrderTypes = getOrderTypes;
exports.getSendInfo = getSendInfo;
exports.getSkuSendList = getSkuSendList;
exports.getSkuSendList2 = getSkuSendList2;
exports.getTaskQueueInfo = getTaskQueueInfo;
exports.getThirdPartyDetail = getThirdPartyDetail;
exports.getTransportAll = getTransportAll;
exports.identifyTransportCompany = identifyTransportCompany;
exports.importFudouStatusChange = importFudouStatusChange;
exports.importSendOrder = importSendOrder;
exports.kamiBindInfo = kamiBindInfo;
exports.loadingFSLOrder = loadingFSLOrder;
exports.movieOrderLists = movieOrderLists;
exports.orderApiOffsetDetail = orderApiOffsetDetail;
exports.orderApiOffsetList = orderApiOffsetList;
exports.orderApiStatusEdit = orderApiStatusEdit;
exports.orderSjtGetDetail = orderSjtGetDetail;
exports.orderSjtList = orderSjtList;
exports.sendAftersale = sendAftersale;
exports.sendOrder = sendOrder;
exports.sendOrderKami = sendOrderKami;
exports.stopExecutingTask = stopExecutingTask;
exports.supplierListArticle = supplierListArticle;
exports.syncHousekeepingStatus = syncHousekeepingStatus;
exports.syncMealStatus = syncMealStatus;
exports.syncMovieStatus = syncMovieStatus;
exports.updataKami = updataKami;
exports.updatePrice = updatePrice;
exports.updateReceive = updateReceive;
var _request = _interopRequireDefault(require("@/utils/request"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } // +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2021 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------
function syncMovieStatus(orderNo) {
  return (0, _request.default)({
    url: "/admin/order/movie/refresh",
    method: 'GET',
    params: {
      orderNo: orderNo
    }
  });
}
function syncMealStatus(orderNo) {
  return (0, _request.default)({
    url: "/admin/order/meal/refresh",
    method: 'GET',
    params: {
      orderNo: orderNo
    }
  });
}

/**
 * 福司令订单刷新
 * @param {string} orderNo - 订单编号
 * @returns
 */
function loadingFSLOrder(orderNo) {
  return (0, _request.default)({
    url: "/admin/callback/refresh",
    method: 'POST',
    data: {
      orderNo: orderNo
    }
  });
}
function exportFinanceList(data) {
  // Ensure startTime and endTime are included in the request
  var exportData = _objectSpread({}, data);

  // If dataRenage exists, extract startTime and endTime
  if (exportData.dataRenage) {
    var _exportData$dataRenag = _slicedToArray(exportData.dataRenage, 2),
      startTimeRange = _exportData$dataRenag[0],
      endTimeRange = _exportData$dataRenag[1];
    if (startTimeRange && endTimeRange) {
      exportData.startTime = startTimeRange;
      exportData.endTime = endTimeRange;
    }
    delete exportData.dataRenage;
  }
  return (0, _request.default)({
    url: "/admin/order/financeDownloadV2",
    method: 'post',
    data: exportData
  });
}

/**
 * 增强版订单导出（新版财务导出）
 * @param {Object} data - 查询参数
 * @returns
 */
function enhancedExportOrderList(data) {
  var exportData = _objectSpread({}, data);

  // If dataRenage exists, extract startTime and endTime
  if (exportData.dataRenage) {
    var _exportData$dataRenag2 = _slicedToArray(exportData.dataRenage, 2),
      startTimeRange = _exportData$dataRenag2[0],
      endTimeRange = _exportData$dataRenag2[1];
    if (startTimeRange && endTimeRange) {
      exportData.startTime = startTimeRange;
      exportData.endTime = endTimeRange;
    }
    delete exportData.dataRenage;
  }
  return (0, _request.default)({
    url: "/admin/order/enhanced/export",
    method: 'post',
    data: exportData
  });
}

/**
 * 快速订单导出（基于EasyExcel高性能导出，异步）
 * @param {Object} data - 查询参数
 * @returns
 */
function fastExportOrderList(data) {
  var exportData = _objectSpread({}, data);
  if (exportData.dataRenage) {
    var _exportData$dataRenag3 = _slicedToArray(exportData.dataRenage, 2),
      startTimeRange = _exportData$dataRenag3[0],
      endTimeRange = _exportData$dataRenag3[1];
    if (startTimeRange && endTimeRange) {
      exportData.startTime = startTimeRange;
      exportData.endTime = endTimeRange;
    }
    delete exportData.dataRenage;
  }
  return (0, _request.default)({
    url: "/admin/order/async/fast/export",
    method: 'post',
    data: exportData
  });
}

// 创建异步增强版订单导出任务
function createAsyncEnhancedExportTask(data) {
  return (0, _request.default)({
    url: "/admin/order/async/enhanced/export",
    method: 'post',
    data: data
  });
}

// 创建异步客户订单导出任务
function createAsyncCustomerExportTask(data) {
  return (0, _request.default)({
    url: "/admin/order/async/customer/export",
    method: 'post',
    data: data
  });
}

/**
 * 客户订单导出（同步，表结构同订单导出但去除成本价、供应商维护人；供应商名称仅线下购物显示）
 * @param {Object} data - 查询参数
 * @returns {Promise<{ fileName: string }>}
 */
function exportCustomerOrderList(data) {
  var exportData = _objectSpread({}, data);
  if (exportData.dataRenage) {
    var _exportData$dataRenag4 = _slicedToArray(exportData.dataRenage, 2),
      startTimeRange = _exportData$dataRenag4[0],
      endTimeRange = _exportData$dataRenag4[1];
    if (startTimeRange && endTimeRange) {
      exportData.startTime = startTimeRange;
      exportData.endTime = endTimeRange;
    }
    delete exportData.dataRenage;
  }
  return (0, _request.default)({
    url: "/admin/order/customer/export",
    method: 'post',
    data: exportData
  });
}

// 查询导出任务状态
function getExportTaskStatus(taskId) {
  return (0, _request.default)({
    url: "/admin/order/async/task/".concat(taskId),
    method: 'get'
  });
}
function getCustomrOrder(param) {
  return (0, _request.default)({
    url: '/admin/order/customer/option',
    method: 'GET',
    params: param
  });
}

/**
 * 列表
 * @param pram
 * @constructor
 */
function ListArticle() {
  var pram = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _ref = pram || {},
    brandId = _ref.brandId,
    limit = _ref.limit,
    orderNo = _ref.orderNo,
    outOrderNo = _ref.outOrderNo,
    pinkStatus = _ref.pinkStatus,
    tagId = _ref.tagId,
    orderType = _ref.orderType,
    card_type = _ref.card_type,
    integralOrderType = _ref.integralOrderType,
    page = _ref.page,
    receiverName = _ref.receiverName,
    receiverPhone = _ref.receiverPhone,
    skuCode = _ref.skuCode,
    spuName = _ref.spuName,
    status = _ref.status,
    statusList = _ref.statusList,
    supplierId = _ref.supplierId,
    categoryId = _ref.categoryId,
    customerId = _ref.customerId,
    customOrderId = _ref.customOrderId,
    cardId = _ref.cardId,
    storeId = _ref.storeId,
    startTime = _ref.startTime,
    endTime = _ref.endTime,
    phone = _ref.phone,
    merchantNo = _ref.merchantNo,
    storeType = _ref.storeType,
    oneCardOrderFlag = _ref.oneCardOrderFlag;
  var data = {
    brandId: brandId,
    limit: limit,
    orderNo: orderNo,
    outOrderNo: outOrderNo,
    tagId: tagId,
    page: page,
    receiverName: receiverName,
    receiverPhone: receiverPhone,
    skuCode: skuCode,
    spuName: spuName,
    status: status,
    supplierId: supplierId,
    categoryId: categoryId,
    orderType: orderType,
    card_type: card_type,
    integralOrderType: integralOrderType,
    customerId: customerId,
    customOrderId: customOrderId,
    cardId: cardId,
    storeId: storeId,
    startTime: startTime,
    endTime: endTime,
    phone: phone,
    merchantNo: merchantNo,
    storeType: storeType,
    oneCardOrderFlag: oneCardOrderFlag
  };
  if (statusList !== undefined) {
    data.statusList = statusList;
    delete data.status;
  }
  ;
  if (data.orderType != 7) {
    delete data.pinkStatus;
  }
  ;
  var _ref2 = data.dataRenage || [],
    _ref3 = _slicedToArray(_ref2, 2),
    startTimeRange = _ref3[0],
    endTimeRange = _ref3[1];
  if (startTimeRange && endTimeRange) {
    data = _objectSpread(_objectSpread({}, data), {}, {
      startTime: startTimeRange,
      endTime: endTimeRange
    });
  }
  ;
  delete data.dataRenage;
  return (0, _request.default)({
    url: '/admin/order/list',
    method: 'POST',
    data: data // 将 params 改为 data
  });
}

/**
 * 订单统计看板汇总（与列表查询条件一致）
 * @param pram 与列表相同的筛选参数（可不传 page/limit）
 */
function getDashboardSummary() {
  var pram = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _ref4 = pram || {},
    brandId = _ref4.brandId,
    orderNo = _ref4.orderNo,
    outOrderNo = _ref4.outOrderNo,
    tagId = _ref4.tagId,
    receiverName = _ref4.receiverName,
    receiverPhone = _ref4.receiverPhone,
    skuCode = _ref4.skuCode,
    spuName = _ref4.spuName,
    statusList = _ref4.statusList,
    supplierId = _ref4.supplierId,
    categoryId = _ref4.categoryId,
    orderType = _ref4.orderType,
    card_type = _ref4.card_type,
    customerId = _ref4.customerId,
    customOrderId = _ref4.customOrderId,
    cardId = _ref4.cardId,
    storeId = _ref4.storeId,
    startTime = _ref4.startTime,
    endTime = _ref4.endTime,
    phone = _ref4.phone,
    merchantNo = _ref4.merchantNo,
    storeType = _ref4.storeType,
    oneCardOrderFlag = _ref4.oneCardOrderFlag;
  var data = {
    brandId: brandId,
    orderNo: orderNo,
    outOrderNo: outOrderNo,
    tagId: tagId,
    receiverName: receiverName,
    receiverPhone: receiverPhone,
    skuCode: skuCode,
    spuName: spuName,
    statusList: statusList,
    supplierId: supplierId,
    categoryId: categoryId,
    orderType: orderType,
    card_type: card_type,
    customerId: customerId,
    customOrderId: customOrderId,
    cardId: cardId,
    storeId: storeId,
    startTime: startTime,
    endTime: endTime,
    phone: phone,
    merchantNo: merchantNo,
    storeType: storeType,
    oneCardOrderFlag: oneCardOrderFlag
  };
  return (0, _request.default)({
    url: '/admin/order/dashboard/summary',
    method: 'POST',
    data: data
  });
}

/**
 * 福豆使用详情（按卡类型）
 */
function getFudouDetail() {
  var pram = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _ref5 = pram || {},
    brandId = _ref5.brandId,
    orderNo = _ref5.orderNo,
    outOrderNo = _ref5.outOrderNo,
    tagId = _ref5.tagId,
    receiverName = _ref5.receiverName,
    receiverPhone = _ref5.receiverPhone,
    skuCode = _ref5.skuCode,
    spuName = _ref5.spuName,
    status = _ref5.status,
    supplierId = _ref5.supplierId,
    categoryId = _ref5.categoryId,
    orderType = _ref5.orderType,
    customerId = _ref5.customerId,
    customOrderId = _ref5.customOrderId,
    startTime = _ref5.startTime,
    endTime = _ref5.endTime,
    phone = _ref5.phone,
    storeType = _ref5.storeType,
    oneCardOrderFlag = _ref5.oneCardOrderFlag;
  var data = {
    brandId: brandId,
    orderNo: orderNo,
    outOrderNo: outOrderNo,
    tagId: tagId,
    receiverName: receiverName,
    receiverPhone: receiverPhone,
    skuCode: skuCode,
    spuName: spuName,
    status: status,
    supplierId: supplierId,
    categoryId: categoryId,
    orderType: orderType,
    customerId: customerId,
    customOrderId: customOrderId,
    startTime: startTime,
    endTime: endTime,
    phone: phone,
    storeType: storeType,
    oneCardOrderFlag: oneCardOrderFlag
  };
  return (0, _request.default)({
    url: '/admin/order/dashboard/fudou-detail',
    method: 'POST',
    data: data
  });
}

/**
 * 第三方支付详情（按渠道）
 */
function getThirdPartyDetail() {
  var pram = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _ref6 = pram || {},
    brandId = _ref6.brandId,
    orderNo = _ref6.orderNo,
    outOrderNo = _ref6.outOrderNo,
    tagId = _ref6.tagId,
    receiverName = _ref6.receiverName,
    receiverPhone = _ref6.receiverPhone,
    skuCode = _ref6.skuCode,
    spuName = _ref6.spuName,
    status = _ref6.status,
    supplierId = _ref6.supplierId,
    categoryId = _ref6.categoryId,
    orderType = _ref6.orderType,
    customerId = _ref6.customerId,
    customOrderId = _ref6.customOrderId,
    startTime = _ref6.startTime,
    endTime = _ref6.endTime,
    phone = _ref6.phone,
    storeType = _ref6.storeType,
    oneCardOrderFlag = _ref6.oneCardOrderFlag;
  var data = {
    brandId: brandId,
    orderNo: orderNo,
    outOrderNo: outOrderNo,
    tagId: tagId,
    receiverName: receiverName,
    receiverPhone: receiverPhone,
    skuCode: skuCode,
    spuName: spuName,
    status: status,
    supplierId: supplierId,
    categoryId: categoryId,
    orderType: orderType,
    customerId: customerId,
    customOrderId: customOrderId,
    startTime: startTime,
    endTime: endTime,
    phone: phone,
    storeType: storeType,
    oneCardOrderFlag: oneCardOrderFlag
  };
  return (0, _request.default)({
    url: '/admin/order/dashboard/third-party-detail',
    method: 'POST',
    data: data
  });
}

/**
 * 供应商列表
 * @param pram
 * @constructor
 */
function supplierListArticle() {
  var pram = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _ref7 = pram || {},
    _ref7$dataRenage = _ref7.dataRenage,
    dataRenage = _ref7$dataRenage === void 0 ? [] : _ref7$dataRenage,
    brandId = _ref7.brandId,
    limit = _ref7.limit,
    orderNo = _ref7.orderNo,
    pinkStatus = _ref7.pinkStatus,
    tagId = _ref7.tagId,
    orderType = _ref7.orderType,
    page = _ref7.page,
    receiverName = _ref7.receiverName,
    receiverPhone = _ref7.receiverPhone,
    skuCode = _ref7.skuCode,
    spuName = _ref7.spuName,
    status = _ref7.status,
    supplierId = _ref7.supplierId,
    categoryId = _ref7.categoryId,
    customerId = _ref7.customerId,
    deliveryStatus = _ref7.deliveryStatus;
  var data = {
    brandId: brandId,
    limit: limit,
    orderNo: orderNo,
    tagId: tagId,
    page: page,
    receiverName: receiverName,
    receiverPhone: receiverPhone,
    skuCode: skuCode,
    spuName: spuName,
    status: status,
    supplierId: supplierId,
    categoryId: categoryId,
    orderType: orderType,
    customerId: customerId,
    deliveryStatus: deliveryStatus
  };
  if (orderType == 7) {
    data['pinkStatus'] = pinkStatus;
  }
  ;
  var _ref8 = dataRenage || [],
    _ref9 = _slicedToArray(_ref8, 2),
    startTime = _ref9[0],
    endTime = _ref9[1];
  if (startTime && endTime) {
    data = _objectSpread(_objectSpread({}, data), {}, {
      startTime: startTime,
      endTime: endTime
    });
  }
  ;
  return (0, _request.default)({
    // url: '/admin/order/supplier/list',
    url: '/admin/order/supplier/list',
    method: 'GET',
    params: data
  });
}

/**
 * 列表-电影
 */
function movieOrderLists() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var data = _objectSpread({}, params);
  var _ref0 = data.dataRenage || [],
    _ref1 = _slicedToArray(_ref0, 2),
    startTime = _ref1[0],
    endTime = _ref1[1];
  if (startTime && endTime) {
    data = _objectSpread(_objectSpread({}, data), {}, {
      startTime: startTime,
      endTime: endTime
    });
  }
  ;
  delete data.dataRenage;
  return (0, _request.default)({
    url: '/admin/order/movie/list',
    method: 'GET',
    params: data
  });
}

/**
 * 详情
 */
function getMovieOrderDetail(orderNo) {
  return (0, _request.default)({
    url: "/admin/order/movie/detail/".concat(orderNo),
    method: 'GET',
    params: {
      orderNo: orderNo
    }
  });
}

/**
 * 导出-电影
 */
function exportMovieOrderList() {
  var pram = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var data = _objectSpread({}, pram);
  var _ref10 = data.dataRenage || [],
    _ref11 = _slicedToArray(_ref10, 2),
    startTime = _ref11[0],
    endTime = _ref11[1];
  if (startTime && endTime) {
    data = _objectSpread(_objectSpread({}, data), {}, {
      startTime: startTime,
      endTime: endTime
    });
  }
  ;
  delete data.dataRenage;
  return (0, _request.default)({
    url: "/admin/export/excel/movieOrder",
    method: 'get',
    params: data
  });
}

/**
 * 详情
 * @param orderNo
 * @param queryParams 额外查询参数
 * @constructor
 */
function getOrderDetail(orderNo) {
  var queryParams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return (0, _request.default)({
    url: "/admin/order/detail/".concat(orderNo),
    method: 'GET',
    params: _objectSpread({
      orderNo: orderNo
    }, queryParams)
  });
}

/**
 * 查询订单商品已发放的一卡通信息。
 */
function getOrderOneCardList(orderNo, orderItemId) {
  return (0, _request.default)({
    url: '/admin/order/one_card_list',
    method: 'GET',
    params: {
      orderNo: orderNo,
      orderItemId: orderItemId
    }
  });
}

/**
 * 详情-供应商
 * @param orderNo
 * @constructor
 */
function getOrderDetail2(orderNo) {
  return (0, _request.default)({
    url: "/admin/order/supplier/detail/".concat(orderNo),
    method: 'GET',
    params: {
      orderNo: orderNo
    }
  });
}

/**
 * 订单优惠记录明细（优惠券/立减，不含卡密）
 * @param orderNo 订单号
 */
function getOrderDiscountDetail(orderNo) {
  return (0, _request.default)({
    url: "/admin/order/discount-detail/".concat(orderNo),
    method: 'GET',
    params: {
      orderNo: orderNo
    }
  });
}

/**
 * 订单发货
 * @param {*} data
 * @returns
 */
function sendOrder(data) {
  return (0, _request.default)({
    url: "/admin/order/shipments",
    method: 'post',
    data: data
  });
}

/**
 * 取消订单
 * @param {*} orderNo
 * @returns
 */
function cancelOrder(data) {
  return (0, _request.default)({
    url: "/admin/order/cancel/".concat(data.orderNo),
    method: 'post',
    data: _objectSpread(_objectSpread({}, data), {}, {
      coupon: true
    })
  });
}

/**
 * 获取物流公司
 * @param {*} keyword
 * @returns
 */
function getTransportAll(keyword) {
  return (0, _request.default)({
    url: "/admin/delivery/select",
    method: 'get',
    params: {
      keyword: keyword
    }
  });
}

/**
 * 根据物流单号识别物流公司
 * @param {*} deliveryNo
 * @returns
 */
function identifyTransportCompany(deliveryNo) {
  return (0, _request.default)({
    url: "/admin/delivery/identify",
    method: 'get',
    params: {
      deliveryNo: deliveryNo
    },
    __skipGlobalErrorMessage: true
  });
}

/**
 * 获取物流轨迹
 * @param {*} orderNo
 * @returns
 */
function getDeliveryTrace(orderNo) {
  return (0, _request.default)({
    url: "/admin/order/delivery/".concat(orderNo),
    method: 'get'
  });
}

/**
 * 发货信息查询
 * @param {*} orderNo
 * @returns
 */
function getSendInfo(orderNo) {
  return (0, _request.default)({
    url: "/admin/order/shipments/".concat(orderNo),
    method: 'get'
  });
}

/**
 * 导出
 * @param {*} data
 * @returns
 */
function exportOrderList(data) {
  // Ensure startTime and endTime are included in the request
  var exportData = _objectSpread({}, data);

  // If dataRenage exists, extract startTime and endTime
  if (exportData.dataRenage) {
    var _exportData$dataRenag5 = _slicedToArray(exportData.dataRenage, 2),
      startTimeRange = _exportData$dataRenag5[0],
      endTimeRange = _exportData$dataRenag5[1];
    if (startTimeRange && endTimeRange) {
      exportData.startTime = startTimeRange;
      exportData.endTime = endTimeRange;
    }
    delete exportData.dataRenage;
  }
  return (0, _request.default)({
    url: "/admin/order/download",
    method: 'post',
    data: exportData
  });
}
/**
 * 订单导出
 * @param {*} data
 * @returns
 */
function exportOrderList2(data) {
  // Ensure startTime and endTime are included in the request
  var exportData = _objectSpread({}, data);

  // If dataRenage exists, extract startTime and endTime
  if (exportData.dataRenage) {
    var _exportData$dataRenag6 = _slicedToArray(exportData.dataRenage, 2),
      startTimeRange = _exportData$dataRenag6[0],
      endTimeRange = _exportData$dataRenag6[1];
    if (startTimeRange && endTimeRange) {
      exportData.startTime = startTimeRange;
      exportData.endTime = endTimeRange;
    }
    delete exportData.dataRenage;
  }
  return (0, _request.default)({
    url: "/admin/order/download2",
    method: 'post',
    data: exportData
  });
}

/**
 * 订单导出
 */
function exportOrderSendList(data) {
  return (0, _request.default)({
    url: "/admin/order/export/item",
    method: 'get'
  });
}

/**
 * 订单导出-供应商版
 */
// export function exportOrderSendList2(data) {
//     return request({
//         url: `/admin/order/supplier/export/item`,
//         method: 'get',
//     });
// }

/**
 * 订单导出-供应商版-庆哥
 */
function exportOrderSendList2(data) {
  return (0, _request.default)({
    url: "/admin/order/supplier/export",
    method: 'post',
    data: data
  });
}

/**
 * 订单导出（拆分）
 */
function exportOrderSendListSplit(data) {
  return (0, _request.default)({
    url: "/admin/order/export-split-zip",
    method: 'get'
  });
}

/**
 * 导入发货
 * @param {*} data
 * @returns
 */
function importSendOrder(data) {
  return (0, _request.default)({
    url: "/admin/order/import",
    method: 'post',
    data: data
  });
}

/**
 * 福豆充值状态变更导入
 * @param {*} data
 * @returns
 */
function importFudouStatusChange(data) {
  return (0, _request.default)({
    url: "/admin/order/import/fudou-status",
    method: 'post',
    data: data
  });
}

/**
 * 售后发货
 */
function sendAftersale() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _ref12 = data || {},
    id = _ref12.id,
    logisticsInfos = _ref12.logisticsInfos;
  return (0, _request.default)({
    url: "/admin/order/aftersale/delivery-logistics/".concat(id),
    method: 'post',
    data: {
      logisticsInfos: logisticsInfos
    }
  });
}

/**
 * 修改订单收货人信息
 */
function updateReceive() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return (0, _request.default)({
    url: "/admin/order/update/receive",
    method: 'put',
    data: data
  });
}

/**
 * 订单改价
 */
function updatePrice() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return (0, _request.default)({
    url: "/admin/order/update/price",
    method: 'put',
    data: data
  });
}

/**
 * 物流发货订单项
 */
function getSkuSendList(orderNo) {
  return (0, _request.default)({
    url: "/admin/order/get/item/".concat(orderNo),
    method: 'get'
  });
}
/**wsw
 * 物流发货订单项 - new wsw2025.07.11
 */
function getSkuSendList2(orderNo) {
  return (0, _request.default)({
    url: "/admin/order/get/supplier/item/".concat(orderNo),
    method: 'get'
  });
}
/**
 * 交易记录-列表
 */
function getOrderPayList() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var data = _objectSpread({}, params);
  var _ref13 = data.dataRenage || [],
    _ref14 = _slicedToArray(_ref13, 2),
    startTime = _ref14[0],
    endTime = _ref14[1];
  if (startTime && endTime) {
    data = _objectSpread(_objectSpread({}, data), {}, {
      startTime: startTime,
      endTime: endTime
    });
  }
  ;
  delete data.dataRenage;
  return (0, _request.default)({
    url: "/admin/payment-records",
    method: 'get',
    params: data
  });
}

/**
 * 交易记录-详情
 */
function getOrderPayDetail(recordId) {
  return (0, _request.default)({
    url: "/admin/payment-records/logs/".concat(recordId),
    method: 'get',
    params: {
      recordId: recordId
    }
  });
}

/**
 * 获取客户
 */
function activeCustomersApi() {
  return (0, _request.default)({
    url: "/admin/customers/active-customers",
    method: 'GET'
  });
}

/**
 * 订单类型
 */
function getOrderTypes() {
  return (0, _request.default)({
    url: "/admin/order/orderTypeList",
    method: 'GET'
  });
}

/**
 * 同步家政订单状态
 * @param {*} data
 * @returns
 */
function syncHousekeepingStatus(orderNo) {
  return (0, _request.default)({
    url: "/admin/order/housekeeping/syncStatus",
    method: 'GET',
    params: {
      orderNo: orderNo
    }
  });
}
function changeOrderState(orderNo) {
  return (0, _request.default)({
    url: "/admin/order/setStatus/".concat(orderNo),
    method: 'get'
  });
}
function sendOrderKami(params) {
  return (0, _request.default)({
    url: "/admin/order/platform-carmine",
    method: 'post',
    params: params
  });
}
function updataKami(params) {
  return (0, _request.default)({
    url: "/admin/order/platform-carmine/update",
    method: 'post',
    params: params
  });
}
function kamiBindInfo(params) {
  return (0, _request.default)({
    url: "/admin/order/platform-carmine/bind-info",
    method: 'post',
    params: params
  });
}

// 订单状态变更
function orderApiStatusEdit(orderNo, status) {
  return (0, _request.default)({
    url: "/admin/order/setStatus/".concat(orderNo, "/").concat(status),
    method: 'get'
  });
}

// 核销订单列表
function orderApiOffsetList(params) {
  return (0, _request.default)({
    url: "/admin/offlineOrder/list",
    method: 'get',
    params: params
  });
}

// 核销订单详情
function orderApiOffsetDetail(id) {
  return (0, _request.default)({
    url: "/admin/offlineOrder/detail/".concat(id),
    method: 'POST'
    // data: { id: orderNo }
  });
}

// 核销订单列表导出（异步）
function exportOfflineOrder(params) {
  return (0, _request.default)({
    url: "/admin/offlineOrder/exportOfflineOrder",
    method: 'get',
    params: params
  });
}

// 查询线下订单导出任务状态
function getOfflineOrderExportTaskStatus(taskId) {
  return (0, _request.default)({
    url: "/admin/offlineOrder/exportOfflineOrderStatus/".concat(taskId),
    method: 'get'
  });
}

// 三甲通订单列表
function orderSjtList(params) {
  return (0, _request.default)({
    url: "/admin/order/sjt/list",
    method: 'get',
    params: params
  });
}

// 三甲通订单详情
function orderSjtGetDetail(params) {
  return (0, _request.default)({
    url: "/admin/order/sjt/getDetail",
    method: 'get',
    params: params
  });
}

// ==================== 异步导出相关API ====================

/**
 * 创建异步订单导出任务
 * @param {*} data
 * @returns
 */
function createAsyncOrderExportTask(data) {
  return (0, _request.default)({
    url: "/admin/order/async/download",
    method: 'post',
    data: data
  });
}

/**
 * 创建异步供应商订单导出任务
 * @param {*} data
 * @returns
 */
function createAsyncSupplierOrderExportTask(data) {
  return (0, _request.default)({
    url: "/admin/order/async/supplier/download",
    method: 'post',
    data: data
  });
}

/**
 * 创建异步财务导出任务
 * @param {*} data
 * @returns
 */
function createAsyncFinanceExportTask(data) {
  return (0, _request.default)({
    url: "/admin/order/async/finance/download",
    method: 'post',
    data: data
  });
}

/**
 * 查询下载任务状态
 * @param {*} taskId
 * @returns
 */
function getDownloadTaskStatus(taskId) {
  return (0, _request.default)({
    url: "/admin/order/async/task/".concat(taskId),
    method: 'get'
  });
}

/**
 * 下载文件
 * @param {*} fileName
 * @returns
 */
function downloadFile(fileName) {
  return (0, _request.default)({
    url: "/admin/order/file/".concat(fileName),
    method: 'get',
    responseType: 'blob'
  });
}

/**
 * ==================== 导出任务管理 API ====================
 */

/**
 * 获取导出任务列表
 * @param {Object} data - 查询参数
 * @returns {Promise}
 */
function getDownloadTaskList(data) {
  return (0, _request.default)({
    url: "/admin/download/task/list",
    method: 'post',
    data: data
  });
}

/**
 * 获取任务详情
 * @param {number} taskId - 任务ID
 * @returns {Promise}
 */
function getDownloadTaskDetail(taskId) {
  return (0, _request.default)({
    url: "/admin/download/task/".concat(taskId),
    method: 'get'
  });
}

/**
 * 删除导出任务
 * @param {number} taskId - 任务ID
 * @returns {Promise}
 */
function deleteDownloadTask(taskId) {
  return (0, _request.default)({
    url: "/admin/download/task/delete/".concat(taskId),
    method: 'post'
  });
}

/**
 * 批量删除过期任务
 * @returns {Promise}
 */
function batchDeleteExpiredTasks() {
  return (0, _request.default)({
    url: "/admin/download/task/batch/delete/expired",
    method: 'post'
  });
}

/**
 * 获取任务统计信息
 * @returns {Promise}
 */
function getDownloadTaskStatistics() {
  return (0, _request.default)({
    url: "/admin/download/task/statistics",
    method: 'get'
  });
}

/**
 * 下载文件（支持通过filePath下载）
 * @param {string} filePath - 文件路径
 * @param {string} fileName - 文件名称
 * @returns {Promise}
 */
function downloadFileByPath(filePath, fileName) {
  try {
    // 统一处理：支持完整URL和相对路径
    var downloadUrl = filePath;
    var httpsIndex = filePath.indexOf('https://');
    if (httpsIndex !== -1) {
      downloadUrl = filePath.substring(httpsIndex);
    } else if (filePath.startsWith('/')) {
      // 相对路径：拼接当前域名
      downloadUrl = window.location.origin + filePath;
    }

    // 创建隐藏的下载链接
    var link = document.createElement('a');
    link.href = downloadUrl;
    link.download = fileName || 'download.xlsx';
    link.target = '_blank';
    link.style.display = 'none';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    return Promise.resolve({
      success: true
    });
  } catch (error) {
    return Promise.reject(error);
  }
}

/**
 * 查询指定类型的导出任务排队信息
 * @param {string} taskType - 任务类型
 * @returns {Promise}
 */
function getDownloadQueueInfo(taskType) {
  return (0, _request.default)({
    url: "/admin/download/task/queue/info",
    method: 'get',
    params: {
      taskType: taskType
    }
  });
}

/**
 * 查询指定任务的排队信息
 * @param {number} taskId - 任务ID
 * @returns {Promise}
 */
function getTaskQueueInfo(taskId) {
  return (0, _request.default)({
    url: "/admin/download/task/queue/info/".concat(taskId),
    method: 'get'
  });
}

/**
 * 获取导出任务排队详情（包含正在执行的任务和排队队列）
 * @param {string} taskType - 任务类型
 * @returns {Promise}
 */
function getDownloadQueueDetail(taskType) {
  return (0, _request.default)({
    url: "/admin/download/task/queue/detail",
    method: 'get',
    params: {
      taskType: taskType
    }
  });
}

/**
 * 取消用户的排队任务
 * @param {number} taskId - 任务ID
 * @returns {Promise}
 */
function cancelQueuedTask(taskId) {
  return (0, _request.default)({
    url: "/admin/download/task/queue/cancel/".concat(taskId),
    method: 'post'
  });
}

/**
 * 中止自己正在执行的导出任务
 * @param {number} taskId - 任务ID
 * @returns {Promise}
 */
function stopExecutingTask(taskId) {
  return (0, _request.default)({
    url: "/admin/download/task/stop/".concat(taskId),
    method: 'post'
  });
}

/**
 * 管理员中止所有用户正在执行的任务
 * @returns {Promise}
 */
function adminStopAllTasks() {
  return (0, _request.default)({
    url: "/admin/download/task/admin/stop-all",
    method: 'post'
  });
}